import axios from "axios";
import { assertApiResponse, getApiErrorMessage } from "./apiFeedback";

// 기본 30초. 일반 GET/POST 는 충분히 빠르므로 이 범위 안에서 처리.
// 다운로드/업로드처럼 더 긴 작업은 호출 시 config.timeout 으로 별도 override (api.download/upload 에서 처리).
function createHttp(baseURL, withAuth = false) {
    const instance = axios.create({ baseURL, timeout: 30000 });

    if (withAuth) {
        instance.interceptors.request.use((config) => {
            const token = localStorage.getItem("auth_token");
            if (token) config.headers["X-TOKEN"] = token;
            return config;
        });
    }

    instance.interceptors.response.use(
        (res) => {
            if (res.config.responseType === "blob" || res.config.responseType === "arraybuffer") return res;
            return assertApiResponse(res);
        },
        (error) => {
            const status = error.response?.status;

            // 로그인 요청의 401 은 '세션 만료' 가 아니라 '비번 틀림' 이다.
            // 여기서 auth:expired 를 쏘면 로그인 화면이 스스로를 다시 강제 로그인 상태로 만든다.
            const isLoginAttempt = (error.config?.url || "").includes("/auth/login");
            if (status === 401 && !isLoginAttempt) {
                window.dispatchEvent(new CustomEvent("auth:expired"));
            }

            /* 예전엔 여기서 new Error(message) 만 던졌다. 그러면 호출부는 <b>status 를 통째로 잃는다</b> —
             * error.response 가 사라지니 401 인지 429 인지 아예 못 보고, 서버가 또박또박 401 을 준
             * 상황까지 "네트워크 오류" 로 뭉뚱그려졌다(로그인 화면이 딱 그랬다).
             * 메시지는 정제해서 담되 status·code 는 살려 둔다 — 호출부가 분기할 수 있게. */
            const err = new Error(getApiErrorMessage(error));
            err.status = status;                 // 서버가 응답했으면 숫자, 응답 자체가 없으면 undefined
            err.response = error.response;
            err.code = error.code;               // ECONNABORTED(타임아웃) / ERR_NETWORK 등 진짜 네트워크 실패
            return Promise.reject(err);
        }
    );

    return instance;
}

// 인증 필요 엔드포인트 (REACT_APP_API_REAL_URL)
export const http     = createHttp(process.env.REACT_APP_API_REAL_URL, true);

// 공개/제안 엔드포인트 (REACT_APP_API_BASE_URL)
export const httpBase = createHttp(process.env.REACT_APP_API_BASE_URL, false);
